module.exports = __webpack_public_path__ + "static/media/npg-jam-supplement.091b4333.pdf";